// One card in the pronunciation drill: the word, its IPA behind a button, and
// the three things you can do about it.
//
// The reveal gate is the point of the exercise. Grading yourself before seeing
// the transcription is grading your confidence, not your pronunciation, so the
// vote buttons stay disabled until the IPA is on screen.

export default function WordCard({ card, revealed, onReveal, onVote, onRetire }) {
  const { word, ipa, good, wrong, attempts } = card;

  return (
    <div className="rounded-2xl border border-slate-800 bg-slate-900/40 p-6 sm:p-10">
      <p className="text-center text-3xl font-semibold tracking-tight text-slate-100 sm:text-4xl">
        {word}
      </p>

      {/* The IPA slot keeps its height whether or not it is filled, so revealing
          an answer does not shift the vote buttons out from under the cursor. */}
      <div className="mt-6 flex min-h-[4.5rem] items-center justify-center">
        {revealed ? (
          <p className="text-center text-2xl text-sky-300 sm:text-3xl">/{ipa}/</p>
        ) : (
          <button
            type="button"
            onClick={onReveal}
            className="rounded-lg border border-slate-700 px-5 py-2.5 text-sm font-medium text-slate-300 transition hover:border-sky-500/50 hover:text-sky-300"
          >
            Show IPA
          </button>
        )}
      </div>

      <p className="mt-2 text-center text-[11px] tabular-nums text-slate-600">
        {attempts === 0
          ? "never tested"
          : `seen ${attempts} · right ${good} · wrong ${wrong}`}
      </p>

      <div className="mt-8 grid grid-cols-2 gap-3">
        <button
          type="button"
          disabled={!revealed}
          onClick={() => onVote("wrong")}
          className="rounded-lg border border-rose-500/30 bg-rose-500/10 px-4 py-3 text-sm font-medium text-rose-300 transition hover:bg-rose-500/20 disabled:cursor-not-allowed disabled:border-slate-800 disabled:bg-transparent disabled:text-slate-700"
        >
          ✗ I got it wrong
        </button>
        <button
          type="button"
          disabled={!revealed}
          onClick={() => onVote("good")}
          className="rounded-lg border border-emerald-500/30 bg-emerald-500/10 px-4 py-3 text-sm font-medium text-emerald-300 transition hover:bg-emerald-500/20 disabled:cursor-not-allowed disabled:border-slate-800 disabled:bg-transparent disabled:text-slate-700"
        >
          ✓ I got it right
        </button>
      </div>

      <div className="mt-4 flex justify-center">
        <button
          type="button"
          onClick={onRetire}
          className="text-xs text-slate-600 transition hover:text-rose-400 disabled:opacity-50"
        >
          🗑 Remove this word from the drill
        </button>
      </div>

      <p className="mt-6 text-center text-[11px] text-slate-700">
        Space reveals · ← wrong · → right
      </p>
    </div>
  );
}
